var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row border-bottom p-05" }, [
    _c("div", { staticClass: "col-md-10" }, [
      _c("div", { staticClass: "text-md-start" }, [
        _c("div", [_vm._v(_vm._s(_vm.company.name))]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-2 text-md-right" }, [
      _c("div", { staticClass: "float-right" }, [
        _c("i", { staticClass: "fa fa-users" }),
        _vm._v(" " + _vm._s(_vm.company.company_users_count) + "\n\n        "),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }